<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.21</b> - Some small QoL stuff</p>
    <div class="ml-5 pb-4 text-blue-400">
      <div class="font-bold mt-2">New Features</div>
      <ul class="ml-4 list-disc">
        <li>Added shop restock timer and animation to show when new items arrive.</li>
        <li>Added button to show/hide battle logs in the Caverns.</li>
      </ul>

      <div class="font-bold mt-2">Bug Fixes</div>
      <ul class="ml-4 list-disc">
        <li>Fixed several bugs related to tearing down caverns room views.</li>
        <li>Fixed Battle Logs / Inn Logs not updating correctly when claiming items.</li>
        <li>Fixed a couple Temple candle/prayer rendering bugs.</li>
      </ul>

      <div class="font-bold mt-2">Performance</div>
      <ul class="ml-4 list-disc">
        <li>Smoothed out the UI transition on returing to surface from Caverns.</li>
      </ul>
    </div>
  </div>
</template>
